import dynamic from "next/dynamic";

export const TrustpilotCustom = dynamic(() => import("./TrustpilotCustom"), {
  ssr: false,
});
